import React from 'react'

import { bool, string } from 'prop-types'

function Label({ icon, text, isDark = false }) {
  return (
    <p className={`datasets-label cgt-overline-lg${isDark ? ' datasets-label--dark' : ''}`}>
      <img src={icon} alt="" width={24} height={24} loading="lazy" />
      {text}
    </p>
  )
}

Label.propTypes = {
  icon: string.isRequired,
  text: string.isRequired,
  isDark: bool,
}

export default Label
